import React, { useEffect, useState } from "react";
import axios from "axios";
import DigitalAssetsChart from "../utils/DigitalAssetsChart";
import PhysicalAssetsChart from "../utils/PhysicalAssetsChart";
import ImageLoading from "../../../components/ImageLoading";

const PhysicalAssets = ({ tab }) => {
  const [graph, setGraph] = useState({});
  const [activeDuration, setActiveDuration] = useState("weekly");

  const dates = [];
  const realEstate = [];
  const vehicle = [];
  const [loading, setLoading] = useState(false);

  const getDashboardUserDetails = async () => {
    setLoading(true);

    const token = localStorage.getItem("token");

    const url = `${process.env.REACT_APP_URL}/lender/v1/dashboards/physical_assets_graph`;
    const options = {
      url: url,
      method: "GET",
      headers: { Authorization: token },
    };
    const res = await axios(options);
    setGraph(res.data.data);
    setLoading(false);
  };

  for (const key in graph) {
    dates.push(key);
    realEstate.push(graph[key].real_estate);
    vehicle.push(graph[key].vehicle);
  }

  useEffect(() => {
    getDashboardUserDetails();
  }, [activeDuration, tab]);

  return (
    <>
      {loading ? (
        <div className="flex w-full h-full justify-center items-center">
          <ImageLoading />
        </div>
      ) : (
        <>
          {" "}
          <div className=" pt-4 h-full  ">
            <div className="flex justify-between items-center mb-[22px] ml-4">
              <p className="text-[16px] font-semibold">Physical Assets</p>
            </div>
            <div className="  pl-[27.5px] pr-[12px]">
              <PhysicalAssetsChart
                dates={dates}
                realEstate={realEstate}
                vehicle={vehicle}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PhysicalAssets;
